import axios from 'axios';
import Qs from 'qs'
//import md5 from 'blueimp-md5'
import { DES3 } from './crypto-js';
//获取接口地址
 // const api = '/api';
const api = '/admin/open';
const commonParam = {
    cityLcode: '320400',
//  deviceId: 'h5',
//  deviceType: 'h5',
    clientTime: new Date().getTime()
}

function msg(content) {
    layer.open({
        skin: 'msg',
        content: content,
        time: 2
    });
}
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {String} params [请求时携带的参数]
 */
export function get(url, params) {
	const token = sessionStorage.getItem("token");
    return new Promise((resolve, reject) => {
    //      commonParam.deviceId = (params.deviceId) ? params.deviceId : 'h5';
        const resT = Object.assign(params && params !== '' ? params : {}, commonParam);
        const resParam = DES3.encrypt(JSON.stringify(resT));
        axios.get(api + url, {
            headers: {
                'token': token
            },
            params: {
                data: resParam
            }
        }).then(res => {
            const data = JSON.parse(DES3.decrypt(res.data));
            console.log('请求接口：' + url);
            console.log(data);
            if (data.errcode === 200) {
                resolve(data)
            } else {
                layer.msg(data.errmsg);
                reject(data.errmsg)
            }
        }).catch(err => {
            resolve({
                errcode: err.response.status,
                errmsg: err.response.status + err.response.statusText,
                data: {}
            })
        })
    });
}

/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {String} params [请求时携带的参数] 
 */
export function post(url, params) {
	console.log(params);
    const token = sessionStorage.getItem("token");
    return new Promise((resolve, reject) => {
    //    commonParam.deviceId = (params.deviceId) ? params.deviceId : 'h5';
        const resT = Object.assign(params && params !== '' ? params : {}, commonParam);
        const resParam = DES3.encrypt(JSON.stringify(resT));
        const parame = Qs.stringify({
            data: resParam
        }); //序列化
        axios.post(api + url, parame, {
            headers: {
                'token': token
            }
        }).then(res => {
            const data = JSON.parse(DES3.decrypt(res.data));
 //           console.log('请求接口：' + url);
            console.log(data);
            if (Object.is(data.errcode, 200)) {
                resolve(data)
            } else if (Object.is(data.errcode, 401)) {
                window.location.href = '/#/login.do'
            } else {
                layer.msg(data.errmsg);
                reject(data.errmsg)
            }
        }).catch(err => {
            parent.layer.msg(err.response.status + err.response.statusText)
        })
    });
}
//导出文件
export function exportFile(url, params) {
    const token = sessionStorage.getItem("token");
    return new Promise((resolve, reject) => {
//        commonParam.deviceId = (params.deviceId) ? params.deviceId : 'h5';
        const resT = Object.assign(params && params !== '' ? params : {}, commonParam);
        const resParam = DES3.encrypt(JSON.stringify(resT));
        const parame = Qs.stringify({
            data: resParam
        }); //序列化
        axios.post(api + url, parame, {
            headers: {
                'token': token
            },
           responseType: 'blob' // 表明返回服务器返回的数据类型
        }).then(res => {
        	console.log(res)
            let fileName = decodeURI(res.headers['content-disposition'].split('=')[1]);
            // 获取文件名
            let objectUrl = URL.createObjectURL(new Blob([res.data]));
            // 文件地址
            const link = document.createElement('a');
            link.download = fileName;
            link.href = objectUrl;
            link.style.display = "none";
            document.body.appendChild(link);//解决火狐不能下载的问题
            link.click();
             document.body.removeChild(link);//没有document.body.appendChild(link);
        }).catch(err => {
        	console.log(err)
           // parent.layer.msg(err)
        })
    });
}
/**
 * post方法，上传图片
 * @param {string} url [请求的url地址]
 * @param {object} file [要上传的文件]
 */
export function upload(url, file, md5String) {

	const token = sessionStorage.getItem("token");
    return new Promise((resolve, reject) => {
        const formFile = new FormData();
        const md5File = {
            md5: md5String
        }
        formFile.append('file', file);
        if (md5String) {
            formFile.append('data', DES3.encrypt(JSON.stringify(md5File)));
        }
        const instance = axios.create({
            withCredentials: true,
            timeout: 1000000
        })
        instance.post(api + url, formFile, {
            headers: {
                'token': token,
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => {
            const data = res.data;
            console.log('请求接口：' + url);
            //     console.log(data);
            if (Object.is(data.errcode, 200)) {
                resolve(data)
            } else if (Object.is(data.errcode, 401)) {
                window.location.href = '/#/login.do'
            } else {
              
                    const data = JSON.parse(DES3.decrypt(res.data));
                      layer.msg(data.errmsg);
                reject(data.errmsg)
            }
        }).catch(err => {
         //   parent.layer.msg(err.response.status + err.response.statusText)
        })
    });
}
//上传excel
export function uploadExcel(url, file, md5String, type) {
		if(file==''){
	  		layer.msg("请选择文件");
	  		return false;
	  	}
	const token = sessionStorage.getItem("token");
	  
    return new Promise((resolve, reject) => {
        const formFile = new FormData();
        const md5File = {
            md5: md5String,
            type: type
        }
        formFile.append('file', file);
        if (md5String) {
            formFile.append('data', DES3.encrypt(JSON.stringify(md5File)));
        }
        const instance = axios.create({
            withCredentials: true,
             timeout: 1000000
        })
        instance.post(api + url, formFile, {
            headers: {
                'token': token,
                'Content-Type': 'multipart/form-data'
            },
      //     responseType: 'text' // 表明返回服务器返回的数据类型
        }).then(res => { //上传成功后导出文件
      
           const data = JSON.parse(DES3.decrypt(res.data));
            if (Object.is(data.errcode, 200)) {
	            	if(data.data.filePath){
	            		const link1 = document.createElement('a');
		            link1.download = data.data.fileName;
		            link1.href =  data.data.filePath;
		            link1.style.display = "none";
		            link1.click();
	            	}
                resolve(data)
            } else if (Object.is(data.errcode, 401)) {
                window.location.href = '/#/login.do'
            } else {
                layer.msg(data.errmsg);
                
                reject(data.errmsg)
            }
        }).catch(err => {
        parent.layer.msg('文件上传失败，请检查文件的格式是否正确');
          //  layer.msg(err.response.status + err.response.statusText)
        })
    });
}


// WEBPACK FOOTER //
// ./src/utils/request.js